// removed by extract-text-webpack-plugin
module.exports = {"showMore":"uzioCMpo5mZOlipxZUiOE","text":"_1W-lT7P-ONa33jga6D0d40"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChartShowMoreToggle/ChartShowMoreToggle.scss
// module id = 1250
// module chunks = 1